/**
 * First we will load all of this project's JavaScript dependencies and apply any initial configurations
 */

/**
 * We will reference a global object that we may use to fetch preset properties
 */
window.RequestInfo = window.RequestInfo || {};


/**Use the Modernizr.js library to determine whether the browser used by the client
 * is compatible with our application, based on the core JS, HTML, and CSS features we employ.
 * ~ see https://modernizr.com/docs
 *
 * To build an updated Modernizr configuration run the npm script;
 *  npm run modernizr-build
 * Which makes use of the ./modernizr-config.json file for setup
 * ~ all available options may be viewed in the example full config file at
 *  ./node_modules/modernizr/lib/config-all.json
 */
require('./modernizr.js');


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
window.Vue = require('vue/dist/vue');


/**
 * We will include Sentry for Error tracking
 * ~see https://docs.sentry.io/error-reporting/quickstart/?platform=node
 *
 * We'll also add a couple additional Sentry js report directives
 * that we will fetch through objects populated by a prior script run on the main app page (app.blade.php)
 * that will populate a RequestInfo object
 * ~ see https://docs.sentry.io/platforms/javascript/guides/vue/
 * ~ see https://sentry.io/mitech-inc-2/user-site-client/getting-started/javascript-vue/
 */
window.Sentry = require('@sentry/vue');
let { Integrations } = require('@sentry/tracing');
window.Sentry.init({
    dsn: process.env.SENTRY_JS_DSN,
    release: process.env.GIT_RELEASE,
    environment: process.env.APP_ENV,

    shutdownTimeout: 5,
    integrations: [new Integrations.BrowserTracing()],
    tracingOptions: {
        trackComponents: true,
    },
    autoSessionTracking: false,
    sampleRate: 1.0,            // for sampling Errors
    tracesSampleRate: 0.0,     // for sampling Transactions
    Vue: window.Vue,

    logErrors: true,
    attachProps: true,

    ignoreErrors: [             // annoying errors we don't care to record
        /null is not an object \(evaluating '\w\.tabIndex'\)/,
        `can't redefine non-configurable property "userAgent"`,
        /.*safari-extension.*/,
        /.*drawChart.*/
    ],

    beforeSend(event) {
        // ~see https://docs.sentry.io/error-reporting/configuration/filtering/?platform=node
        // We only want Sentry to report error in a production or staging environment
        if (process.env.APP_ENV !== 'dev'){
            return event;
        }
    }
});

window.Sentry.configureScope((scope) => {
    scope.setUser({'id': window.RequestInfo.user.card});
    scope.setTag('project_title', `Laundroworks (Client)`);
});


/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
try {
    window.$ = window.jQuery = require('jquery');
    require('bootstrap/dist/js/bootstrap');
} catch (e) {}